<table class="color-palette">
    <tr *ngFor="let row of rows">
        <td *ngFor="let color of row" class="color-option" [style.backgroundColor]="color" (click)="selectColor(color, true)">
            <span *ngIf="color === this.selectedColor" [style.color]="getCheckColor(color)">&#10004;</span>
        </td>
    </tr>
</table>
